import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

export const StyledSectionText = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('300')};

    p[class*='_purpur-paragraph_'] {
        line-height: ${getPurpurTypography('lineHeightLooser')};
    }
`;

export const StyledHeading = styled(Heading)`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
`;
